// Bound memory while keeping the beginning of a long recording and its recent
// high-resolution samples. Repeated compaction progressively thins old data.
export function retainHeartRateSessionSamples(samples, maxSamples = 28800) {
  if (!Array.isArray(samples) || samples.length <= maxSamples) return samples;
  const recentStart = Math.floor(samples.length / 2);
  const older = samples.slice(0, recentStart)
    .filter((_, index) => index % 2 === 0)
    .map((sample) => ({ ...sample, sparse: true }));
  return [...older, ...samples.slice(recentStart)];
}

export function compactHeartRateRecoverySamples(samples, maxSamples = 10000, spacingMs = 5000) {
  if (!Array.isArray(samples) || !samples.length) return [];
  const compact = [];
  let lastTs = -Infinity;
  for (const sample of samples) {
    const ts = Number(sample?.ts);
    if (!Number.isFinite(ts) || ts <= 0) continue;
    if (ts - lastTs >= spacingMs) {
      compact.push(sample);
      lastTs = ts;
    }
  }
  const last = samples[samples.length - 1];
  if (Number.isFinite(Number(last?.ts)) && compact[compact.length - 1] !== last) {
    compact.push(last);
  }
  if (compact.length <= maxSamples) return compact;
  const stride = Math.ceil(compact.length / maxSamples);
  const reduced = compact.filter((_, index) => index % stride === 0);
  if (reduced[reduced.length - 1] !== last) reduced.push(last);
  return reduced;
}
